<template>
  <v-dialog v-model="show" hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Cronogramas Activos</v-toolbar-title>
      </v-toolbar>

     
      <v-data-table
        :headers="headers"
        :items="this.listaCronogramas"
        class="elevation-1"
        :hide-default-footer="true"
        locale="es-ar"
        item-key="idCronograma"
        :disable-sort="true"
      >
        <template v-slot:item.disponibleWeb="{ item }">
          <v-simple-checkbox v-model="item.disponibleWeb" disabled></v-simple-checkbox>
        </template>
      
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.stop="show=false">Salir</v-btn>
      </v-card-actions>
     
    </v-card>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../axios-auth";

export default {
  data: vm => ({
   
    listaCronogramas: [],
    headers: [
      { text: "Dia", value: "nombreDia" },
      { text: "Hora Desde", value: "horaInicioString" },
      { text: "Hora Hasta", value: "horaFinString" },
      { text: "Vigencia Desde", value: "fechaInicioString" },
      { text: "Vigencia Hasta", value: "fechaFinString" },
      { text: "Tiempo Turno", value: "tiempoTurnoNombre" },
      { text: "Disponible Web", value: "disponibleWeb" },
      
    ]
  }),
  computed: {
    show: {
      get() {
        if(this.visible)
          this.cargarCronogramas();
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.listaCronogramas = []
          this.$emit("close");
        }
      }
    }
  },
  props:["visible","prof"],
  created() {
   
    
    
  },
  methods: {
      cargarCronogramas() {
      const datosCronograma = {
        idProfesional: this.prof
      };
      let self = this;
      axios
        .get("/Turnos/ConsultarCronogramas?", {
          params: {
            soloVigentes: true,
            idProfesional: datosCronograma.idProfesional
          }
        })
        .then(response => {
          self.listaCronogramas = response.data;
        })
        .catch(error => {
          self.listaCronogramas = [];
          
        });
    },
  }
};
</script>